import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/Global.css';

// Login agora usa cookie httpOnly em vez de token no localStorage — isso faz
// toda chamada axios do app enviar o cookie de sessao automaticamente.
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);




reportWebVitals();
